module.exports = function() {
  return new Worker(__webpack_public_path__ + "9a8e6c96ccfa02df76f7.worker.js");
};